/**
 * @copyright @2024 Dream Team Cell C. All rights reserved.
 * @description Paper component to override default Mui Paper's style.
 * --------------------------------------------------------------------
 * Creation Details
 * @author Naishad Vaishnav
 * Date Created: 24/Apr/2024
 * Test Case Ref:
 */

// ----------------------------------------------------------------------

/**
 * Paper contains the styles to override default Mui Paper and it's children's styles.
 *
 * @component
 * @returns Add-on styles for MuiPaper
 */
export default function Paper() {
  /* Output */
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },

      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    }
  };
}
